<template>
  <v-dialog v-model="isActive"
            :persistent="isPersistent"
            :scrim="scrim"
            @keydown.esc="cancelAndClose"
            width="500">
    <v-sheet class="pa-2">
      <v-sheet class="d-flex justify-end">
        <v-btn icon="mdi-close" @click="cancelAndClose" flat density="comfortable"></v-btn>
      </v-sheet>
      <v-sheet class="px-4">
        <span class="d-flex text-subtitle-1 font-weight-bold mx-2">{{ t('restore-last-archive.text') }}</span>
        <v-sheet class="pa-4">
          <v-row>
            <v-col offset="1" cols="5" class="d-flex">
              <v-btn @click="cancelAndClose" variant="text" border size="large"
                     class="flex-grow-1 text-none text-body-1 font-weight-bold"
                     color="primary">
                {{ t('cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="5" class="d-flex">
              <v-btn color="primary"
                     :loading="loading"
                     data-cy="confirm-button"
                     @click="onConfirmClick"
                     size="large"
                     flat class="flex-grow-1 text-none text-body-1 font-weight-bold">
                {{ t('confirm') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
      </v-sheet>
    </v-sheet>

  </v-dialog>
</template>
<script setup lang="ts">

import type {ToastType} from "~/composables/openToast";
import {useI18n} from "vue-i18n";

const {t} = useI18n()
export type RestoreReturnDialogValue = { toastType: ToastType }
const loading = ref(false)
const diagnosticStore = useDiagnosticStore()
const isActive = ref(true)

const {close} = defineProps<{
  close: (value: RestoreReturnDialogValue) => void
  isPersistent: boolean
  scrim: boolean
}>()

const onConfirmClick = async () => {
  loading.value = true
  let result = await diagnosticStore.restoreLastDiagnostic()
  diagnosticStore.fetchDiagnosticByStore()
  loading.value = false
  close({toastType: result ? 'success' : 'error'})
}
const cancelAndClose = () => close({toastType: 'canceled'})

</script>

